import { doc, Firestore, setDoc } from "firebase/firestore";

export const setWeightGoal = (db: Firestore, userId: string, date: Date, weight: number): Promise<void> => {
  const docRef = doc(db, "tracker", userId, "weight_goals", "weight_goal");

  return setDoc(docRef, { weight, date });
};
